import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';

export type FindingModalProps = {
    data: {
        mode: string,
        source: string,
        tasks: number,
        events: number,
        findingID: number,
        finding: string,
        category: string,
        calculate_cost_impact: boolean;
        filters : any,
        filterSummary : any,
        automation_opportunity : any,
        type: string,
        finding_type: string,
        save_activities: boolean,
        save_steps: boolean,
        save_variants: boolean,
        filter_activities: string,
        filter_variants: string,
        filter_steps: string,
    }
}


export const openFindingModal = ({ data }:  FindingModalProps) => {
    getEventEmitter().emit(Event.openFindingModal, { data });
};

